import ResourseStore from "./ResourseStore";
import { AxiosInstance } from "axios";
import { action } from "mobx";

export default class AchievementsStore extends ResourseStore {
  url: string;
  client: AxiosInstance;

  getAchievements: (() => any);

  constructor(url: string, client: AxiosInstance) {
    super(url, client);
    this.url = url;
    this.client = client;

    this.getAchievements = action(() => {
      return this.client.get(`/api/achievements/?owner_type=user&first_stage_achievements=1`).then(resp => resp.data)
    })
  }
};
